module.exports = __webpack_public_path__ + "img/rightSlope.71db0450.png";